var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h5", { staticClass: "text-center" }, [
      _vm._v("Для подтверждения операции введите код"),
    ]),
    _vm._v(" "),
    _c("h3", { staticClass: "text-center" }, [
      _c("strong", [_vm._v(_vm._s(_vm.code))]),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.setCode,
            expression: "setCode",
          },
        ],
        staticClass: "form-control",
        attrs: { type: "number", placeholder: "Код" },
        domProps: { value: _vm.setCode },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.setCode = $event.target.value
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }